export default __webpack_public_path__ + "static/media/ic_notification_active.2691c73d.svg";